/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddTrainingRoomCameraLayoutPresetRequest} from "../model/add-training-room-camera-layout-preset-request";
import {AddTrainingRoomRequest} from "../model/add-training-room-request";
import {AudioOutputChannel} from "../model/audio-output-channel";
import {ChangeCameraInRoomRequest} from "../model/change-camera-in-room-request";
import {DeleteTrainingRoomCameraLayoutPresetRequest} from "../model/delete-training-room-camera-layout-preset-request";
import {DeleteTrainingRoomRequest} from "../model/delete-training-room-request";
import {GetCameraSnapshotsRequest} from "../model/get-camera-snapshots-request";
import {MoveTrainingRoomRequest} from "../model/move-training-room-request";
import {SuccessResponse} from "../model/success-response";
import {TrainingRoom} from "../model/training-room";
import {TrainingRoomType} from "../model/training-room-type";
import {UpdateRecorderConfigurationResponse} from "../model/update-recorder-configuration-response";
import {UpdateTrainingRoomCameraLayoutPresetRequest} from "../model/update-training-room-camera-layout-preset-request";
import {UpdateTrainingRoomNameRequest} from "../model/update-training-room-name-request";
import {WebCameraView} from "../model/web-camera-view";

@Injectable({
    providedIn: "root",
})
export class SimStageDesignerService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Convenience function for placing single cameras in rooms
 */ 

    public addCameraToRoom(request: ChangeCameraInRoomRequest) {
        return super.post<TrainingRoom>(`/api/StageDesigner/AddCameraToRoom`, request);
    }

    public addPresetCameraLayout(request: AddTrainingRoomCameraLayoutPresetRequest) {
        return super.post<SuccessResponse>(`/api/StageDesigner/AddPresetCameraLayout`, request);
    }
/**
 * Dependency to simservice removed.
 */ 

    public addTrainingRoom(request: AddTrainingRoomRequest) {
        return super.post<TrainingRoom>(`/api/StageDesigner/AddTrainingRoom`, request);
    }

    public deletePresetCameraLayout(request: DeleteTrainingRoomCameraLayoutPresetRequest) {
        return super.post<SuccessResponse>(`/api/StageDesigner/DeletePresetCameraLayout`, request);
    }

    public deleteTrainingRoom(request: DeleteTrainingRoomRequest) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/StageDesigner/DeleteTrainingRoom`, request);
    }

    public getAvailableVideoSourcesForRoom(trainingRoomId: string) {
        return super.get<WebCameraView[]>(`/api/StageDesigner/GetAvailableVideoSourcesForRoom`, {trainingRoomId: trainingRoomId});
    }

    public getCameraSnapshots_Url(request: GetCameraSnapshotsRequest) {
        return super.getUrl(`/api/StageDesigner/GetCameraSnapshots`, );
    }

    public getCameraSnapshotsByCameraId_Url(cameraId: string) {
        return super.getUrl(`/api/StageDesigner/GetCameraSnapshotsByCameraId`, {cameraId: cameraId});
    }

    public getCameraSnapshotsByToken_Url(token: string) {
        return super.getUrl(`/api/StageDesigner/GetCameraSnapshotsByToken`, {token: token});
    }

    public getVogChannels() {
        return super.get<AudioOutputChannel[]>(`/api/StageDesigner/GetVogChannels`, );
    }

    public getVopChannels() {
        return super.get<AudioOutputChannel[]>(`/api/StageDesigner/GetVopChannels`, );
    }

    public getVttChannels() {
        return super.get<AudioOutputChannel[]>(`/api/StageDesigner/GetVttChannels`, );
    }

    public moveTrainingRoom(request: MoveTrainingRoomRequest) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/StageDesigner/MoveTrainingRoom`, request);
    }

    public refreshCameraSnapshot(cameraId: string) {
        return super.get<boolean>(`/api/StageDesigner/RefreshCameraSnapshot`, {cameraId: cameraId});
    }
/**
 * Convenience function for removing single cameras from rooms
 */ 

    public removeCameraFromRoom(request: ChangeCameraInRoomRequest) {
        return super.post<TrainingRoom>(`/api/StageDesigner/RemoveCameraFromRoom`, request);
    }

    public trainingRooms(type: TrainingRoomType) {
        return super.get<TrainingRoom[]>(`/api/StageDesigner/TrainingRooms`, {type: type});
    }

    public updateCameraStates() {
        return super.post<void>(`/api/StageDesigner/UpdateCameraStates`, {});
    }

    public updatePresetCameraLayout(request: UpdateTrainingRoomCameraLayoutPresetRequest) {
        return super.post<SuccessResponse>(`/api/StageDesigner/UpdatePresetCameraLayout`, request);
    }

    public updateTrainingRoomName(request: UpdateTrainingRoomNameRequest) {
        return super.post<UpdateRecorderConfigurationResponse>(`/api/StageDesigner/UpdateTrainingRoomName`, request);
    }

    public videoSources() {
        return super.get<WebCameraView[]>(`/api/StageDesigner/VideoSources`, );
    }
}